module.exports = __webpack_public_path__ + "img/IMG_1980.3b4547c9.jpg";